import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/common/hd_prev_btn.png'
import _imports_1 from '@/assets/user/form_ico1.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { id: "header" }
const _hoisted_4 = { class: "header_wrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "logo" }, "META HEALTH", -1)
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "비밀번호 찾기", -1)
const _hoisted_10 = { id: "user_form" }
const _hoisted_11 = { class: "input_wrap" }
const _hoisted_12 = {
  key: 0,
  class: "input_box",
  id: "email_box"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ico" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_14 = { class: "email_box" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "@", -1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<option value=\"naver.com\">naver.com</option><option value=\"gmail.com\">gmail.com</option><option value=\"hanmail.net\">hanmail.net</option><option value=\"kakao.com\">kakao.com</option><option value=\"직접입력\">직접입력</option>", 5)
const _hoisted_21 = [
  _hoisted_16
]
const _hoisted_22 = { class: "input_box" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "tit" }, "인증코드 입력", -1)
const _hoisted_24 = { class: "cert_num_box" }
const _hoisted_25 = { class: "cert_btns" }
const _hoisted_26 = {
  key: 0,
  class: "mini_submit_btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthTimer = _resolveComponent("AuthTimer")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "menu_btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
          }, _hoisted_6),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("form", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            ($setup.state.changeBox)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.email) = $event)),
                      placeholder: "이메일"
                    }, null, 512), [
                      [_vModelText, $setup.state.email]
                    ]),
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "",
                      style: _normalizeStyle(!$setup.state.showDomain ? 'display:block' : 'display:none'),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.domain) = $event)),
                      placeholder: "직접입력",
                      class: "direct_email"
                    }, null, 4), [
                      [_vModelText, $setup.state.domain]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      style: _normalizeStyle(!$setup.state.showDomain ? 'display:block' : 'display:none'),
                      class: "email_change_btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.emailChangeBtn && $setup.emailChangeBtn(...args)))
                    }, null, 4),
                    ($setup.state.showDomain)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          name: "",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.domain) = $event)),
                          id: "email_select",
                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.selecetDomail && $setup.selecetDomail(...args)))
                        }, _hoisted_21, 544)), [
                          [_vModelSelect, $setup.state.domain]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "cert_box",
              style: _normalizeStyle(!$setup.state.changeBox ? 'display:block' : 'display:none')
            }, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.applyCode) = $event))
                  }, null, 512), [
                    [_vModelText, $setup.state.applyCode]
                  ]),
                  _createVNode(_component_AuthTimer, {
                    timer: $setup.state.timer,
                    onEnd: $setup.timeOut
                  }, null, 8, ["timer", "onEnd"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  class: "re_send_btn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.requestApplyCode && $setup.requestApplyCode(...args)))
                }, "재전송"),
                _createElementVNode("button", {
                  type: "button",
                  class: "cert_ok_btn",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.checkCode && $setup.checkCode(...args)))
                }, "인증")
              ])
            ], 4)
          ]),
          ($setup.state.changeBox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("button", {
                  type: "button",
                  id: "submit_btn",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.requestApplyCode && $setup.requestApplyCode(...args)))
                }, "인증요청")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ModalComponent, {
          show: $setup.state.isModalOpen,
          yes: $setup.modal.confirm,
          no: $setup.modal.cancel,
          content: $setup.modal.content,
          onClose: $setup.modalClose
        }, null, 8, ["show", "yes", "no", "content", "onClose"])
      ])
    ])
  ]))
}